"use strict"

let VutBox;

export class Renderer {
    
    static init(VB) {
        VutBox=VB;
    }
    
    static render(box) {
        
        clearTimeout(box.killTimeout);

        VutBox.container.classList.remove('vutbox-fade-out');
        
        if (VutBox.container.parentNode != document.body) {
            VutBox.container.classList.add('vutbox-fade-in');
            document.body.appendChild(VutBox.container);
        }
        if (!VutBox.container.querySelector('.vutbox-overlay')) {
            VutBox.container.insertAdjacentHTML('afterBegin', '<div class="vutbox-overlay"></div>')
        }

        document.documentElement.style.setProperty("--vutbox-scrollbar-width", (VutBox.container.offsetWidth-VutBox.container.clientWidth)+'px');

        if ( (box.outer.parentNode) ) {
            box.outer.parentNode.removeChild(box.outer);
        }

        if ( (box.outer.parentNode) ) {
            box.inner.parentNode.removeChild(box.inner);
        }
        
        box.outer.setAttribute('class', 'vutbox-outer'+(VutBox.isAlert(box)||!box.alive?' vutbox-fade-in':'')+(box.id?' vutbox-id-'+box.id:''));
        box.outer.innerHTML='';

        box.inner.setAttribute('class', 'vutbox-inner');
        box.inner.innerHTML='';

        box.closeButton.setAttribute('class', 'vutbox-close vutbox-close-button');
        box.closeButton.innerHTML='<span class="icon-cross2"></span>';
        
        if (box.cfg && (typeof box.cfg=='object')) {

            if (box.cfg.closable) {
                box.outer.appendChild(box.closeButton);
            } else if (box.closeButton.parentNode) {
                box.closeButton.parentNode.removeChild(box.closeButton);
            }
        }

        if ((box.content instanceof VutBox.Dialog)||(box.content instanceof VutBox.Grid)) {
            box.content.render(box);
        } else if (typeof box.content==='function') {
            try {
                let ret=box.content(box);
                if (typeof ret !== 'undefined') {
                    box.inner.innerHTML=ret;
                }
            } catch(e) {console.error(e); box.inner.innerHTML='';}
        } else {
            try {box.inner.innerHTML=box.content.toString();}
            catch(e) {box.inner.innerHTML='';}
        }           
        
        box.outer.appendChild(box.inner);
        VutBox.container.appendChild(box.outer);

        Renderer.runScripts(box);

        box.alive=true;
        
        // VutBox.clearWindowDimensions();

        Renderer.resize(box);

        // VutBox.clearWindowDimensions();
        
        VutBox.focus(box);
        
        let e;
        if (e=box.inner.querySelector('.focus-me')) {
            e.focus();
        } else {
            setTimeout(()=>VutBox.__keytab(box, false, true), 5);
        }
        
        return box;
        
    }

    static runScripts(box) {
        let e=box.inner.querySelectorAll('script');
        for (let i=0; e[i]; i++) {
            try {
                let parent=e[i].parentNode;
                parent.removeChild(e[i]);
                let script=document.createElement('script');
                script.name='vutbox-created-script';
                if (e[i].src) {script.src=e[i].src||"";}
                else if (e[i].innerHTML) {script.innerHTML=e[i].innerHTML;}
                parent.appendChild(script);
            } catch(e) {
                console.error("VutBox: chyba skriptu:", e);
            }

        }
        
    }

    static resize(box, smooth = false, timeout=true) {

        if (!box.shown) return;
        if (!smooth) VutBox.smoothLock = true;

        clearTimeout(box.resizeTimeout);
        if (timeout) {
            box.resizeTimeout = setTimeout(()=>Renderer.resize(box, smooth, false), 25);
            return;
        }

        let outerStyle = getComputedStyle(box.outer);
        let innerStyle = getComputedStyle(box.inner);

        let oldStyle = box.outer.getAttribute('style')
        box.outer.classList.remove('vutbox-transition')
//        box.outer.removeAttribute('style');
        box.outer.classList.add('----resize----measure');

        let innerRect = box.inner.getBoundingClientRect();

        box.outer.classList.remove('----resize----measure');

        let plusWidth =
            parseFloat(outerStyle.paddingLeft)
            + parseFloat(outerStyle.paddingRight)
            + parseFloat(innerStyle.marginLeft)
            + parseFloat(innerStyle.marginRight)
        ;
        let plusHeight =
            parseFloat(outerStyle.paddingTop)
            + parseFloat(outerStyle.paddingBottom)
            + parseFloat(innerStyle.marginTop)
            + parseFloat(innerStyle.marginBottom)
        ;

        let newWidth = Math.ceil(plusWidth + innerRect.width);
        let newHeight = Math.ceil(plusHeight + innerRect.height);
        let oldOverflowY = innerStyle.overflowY;
        box.inner.style.overflowY = (newHeight > parseInt(outerStyle.maxHeight) ? 'auto' : 'hidden');
        box.inner.style.overflowX = (newWidth > parseInt(outerStyle.maxWidth) ? 'auto' : 'hidden');

        newWidth += box.inner.style.overflowY == 'hidden'
            ? 0
            : (parseInt(document.documentElement.style.getPropertyValue('--vutbox-scrollbar-width') || 0) || 0)
        ;
        let newStyle =
            'width:' + newWidth + 'px;'
            + 'height:' + newHeight + 'px;'
        ;

        if (oldStyle === newStyle) return;

        if (smooth && !VutBox.smoothLock && (oldStyle !== newStyle)) {
        //    box.outer.setAttribute('style', oldStyle);
            box.resizeTimeout = setTimeout(()=>{
                box.outer.classList.add('vutbox-transition');
                box.resizeTimeout = setTimeout(()=>box.outer.setAttribute('style', newStyle), 25);
            }, 25);

        } else {
            box.outer.setAttribute('style', newStyle);
            VutBox.smoothLock = false;
        }

    }

/*
    static resize(box, smooth=false, timeout=true){

        clearTimeout(box.resizeTimeout);

        if (box.shown) {

            let scrollLeft = box.inner.dataset.scrollLeft, scrollTop = box.inner.dataset.scrollTop;

            VutBox.getWindowDimensions();

            box.outer.classList.add('----resize----measure');
//return;
            let innerRect=box.inner.getBoundingClientRect();
            let outerStyle=window.getComputedStyle(box.outer);
                                                                // safari fix....
            let targetWidth=Math.ceil(Math.max(innerRect.width, box.inner.scrollWidth)+parseFloat(outerStyle.borderLeftWidth)+parseFloat(outerStyle.borderRightWidth)+parseFloat(outerStyle.paddingLeft)+parseFloat(outerStyle.paddingRight));
            let targetHeight=Math.ceil(Math.max(innerRect.height, box.inner.scrollHeight)+parseFloat(outerStyle.borderTopWidth)+parseFloat(outerStyle.borderBottomWidth)+parseFloat(outerStyle.paddingTop)+parseFloat(outerStyle.paddingBottom));
//return;
            let width=Math.max(
                Math.min(
                    Math.ceil(parseFloat(outerStyle.maxWidth)||Infinity),
                    targetWidth
                ),
                Math.ceil(parseFloat(outerStyle.minWidth)||0),                
            );
            let height=Math.max(
                Math.min(
                    Math.ceil(parseFloat(outerStyle.maxHeight)||Infinity),
                    targetHeight
                ),
                Math.ceil(parseFloat(outerStyle.minHeight)||0),                
            );

            box.inner.setAttribute(
                'style',
                'max-height:100%;'
                +'max-width:100%;'
                +'overflow-y:'+(targetHeight>height?'auto':'hidden')+';'
                +'overflow-x:'+(targetWidth>width?'auto':'hidden')+';'
            );

            box.outer.classList.remove('----resize----measure');
// return;
            if (box.inner.scrollTo) { box.inner.scrollTo(scrollLeft, scrollTop); }

            if (smooth&&timeout) {box.resizeTimeout=setTimeout(()=>Renderer.resize(box, true, false), 150); return;} // kdyby jich přišlo víc... 

            let offset=(box.closeButton instanceof HTMLElement)&&box.closeButton.offsetParent?-box.closeButton.offsetTop:0;

            let left=Math.round((VutBox.window.width-width)/2);
            let top=Math.max(offset, Math.round((VutBox.window.height-height)/2));
            
            box.outer.classList[smooth?'add':'remove']('vutbox-transition');
//return;
            box.outer.setAttribute(
                'style', 
                'left:'+left+'px;'
                +'top:'+top+'px;'
                +'height:'+height+'px;'
                +'width:'+width+'px;'
            );        
// return;
            if (box.inner.scrollTo) { box.inner.scrollTo(scrollLeft, scrollTop); }

            box.resizeTimeout=setTimeout(()=>{
                if ((targetHeight<=height)&&(targetWidth<=width)) {
                    box.inner.removeAttribute('style');
                } else if (targetHeight<=height) {
                    box.inner.style.maxHeight='';
                } else if (targetWidth<=width) {
                    box.inner.style.maxWidth='';                    
                }
                if (box.inner.scrollTo) { box.inner.scrollTo(scrollLeft, scrollTop); }
                box.inner.classList.remove('--resizing');
            }, 200);

        }

        VutBox.smoothLock=false;

    }
*/
        
}

window.addEventListener('blur', (event)=>{
    let e;
    while ( e = document.querySelector('.vutbox-transition') ) {e.classList.remove('vutbox-transition')}
    while ( e = document.querySelector('.vutbox-fade-in') ) {e.classList.remove('vutbox-fade-in')}
}, false)


let transitionend = (event) => {
    event.target?.closest?.('.vutbox-transition')?.classList?.remove?.('vutbox-transition');
    event.target?.closest?.('.vutbox-fade-in')?.classList?.remove?.('vutbox-fade-in');
}

'transitionend,transitioncancel,animationend,animationcancel'.split(',').forEach(e=>window.addEventListener(e, transitionend, true));